// extracted by mini-css-extract-plugin
export default {"wrapper":"successPin_wrapper__ahkku","logo":"successPin_logo__tVB9z","container":"successPin_container__GthVv","header":"successPin_header__BJdUe","p":"successPin_p__LkS6A"};